import { headlines } from "@/mocks/homeData";

export default function HeadlineList() {
  return (
    <section id="headlines" className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日头条</h2>
            <p className="mt-2 text-sm text-foreground-500">黑料社网今日黑料，按更新顺序排列，最新在前。</p>
          </div>
          <a
            href="#stories"
            className="hidden items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 sm:flex"
          >
            更多爆料
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>

        <div className="flex flex-col gap-2">
          {headlines.map((item, index) => (
            <a
              key={item.title}
              href="#stories"
              className="group flex items-center gap-4 rounded-lg border border-transparent bg-background-50 p-3 transition-colors hover:border-background-300 md:gap-6 md:p-4"
            >
              <span className="w-8 shrink-0 text-center font-heading text-2xl font-black text-foreground-200 transition-colors group-hover:text-primary-500 md:text-3xl">
                {index + 1}
              </span>

              <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md md:h-20 md:w-20">
                <img
                  src={item.image}
                  alt={`黑料社网今日黑料 - ${item.title}`}
                  title={`${item.title} - 黑料社网最新爆料`}
                  className="h-full w-full object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="rounded-sm bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-500">{item.time}</span>
                </div>
                <h3 className="mt-1.5 line-clamp-1 font-heading text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
                  {item.title}
                </h3>
                <div className="mt-1 hidden items-center gap-4 text-[11px] text-foreground-500 sm:flex">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line" />
                    {item.heat}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {item.comments} 条评论
                  </span>
                </div>
              </div>

              <span className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-500 transition-colors group-hover:border-primary-500 group-hover:text-primary-500 md:flex">
                <i className="ri-arrow-right-line" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}